const sortArr = (arrToSort, byKey, reverse = false) =>
  arrToSort.sort((a, b) =>
    !reverse ? Number(a[byKey]) - Number(b[byKey]) : Number(b[byKey]) - Number(a[byKey])
  );

export default sortArr;
